<template>

    <div>
        <el-row>
            <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home/welcome' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/home/user' }">基础设置</el-breadcrumb-item>
                    <el-breadcrumb-item>提成比例</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-form :model="percentage" class="demo-form-inline" size="mini">
                    <el-form-item label="名称" :label-width="formLabelWidth">
                        <el-input v-model="percentage.condition.percentageName" placeholder="用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" :label-width="formLabelWidth">
                        <el-select v-model="percentage.condition.percentageStatus" filterable placeholder="请选择">
                            <el-option
                            v-for="item in dataStatuses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期 从" :label-width="formLabelWidth">
                        <el-date-picker type="date" placeholder="选择日期" v-model="percentage.condition.createTimeStart" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="创建日期 到" :label-width="formLabelWidth">
                        <el-date-picker type="date" placeholder="选择日期" v-model="percentage.condition.createTimeEnd" format="yyyy-MM-dd" valueFormat="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="queryPercentage">查询</el-button>
                        <el-button type="primary" @click="createPercentage">新增</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <!-- <el-row type="flex" style="justify-content: right;" class="button-row">
            <el-button type="primary" @click="createPercentage">新增</el-button>
        </el-row> -->
        <el-row>
            <el-col :span="24">
                <el-table
                    :data="percentages"
                    size="mini"
                    border
                    v-loading="loading"
                    empty-text="暂无数据"
                    style="width: 100%">
                    <el-table-column prop="percentageName" label="名称" width="200"></el-table-column>
                    <el-table-column prop="percentageStatus" label="状态" width="100" :formatter="formatStatus"></el-table-column>
                    <el-table-column prop="totalRatio" label="总分成比例" width="150">
                        <template slot-scope="scope"> {{scope.row.totalRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="salerRatio" label="销售比例" width="200">
                        <template slot-scope="scope"> {{scope.row.salerRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="receiverRatio" label="接单比例" width="200">
                        <template slot-scope="scope"> {{scope.row.receiverRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="operatorRatio" label="操作比例" width="200">
                        <template slot-scope="scope"> {{scope.row.operatorRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="auxiliaryRatio" label="辅助比例" width="200">
                        <template slot-scope="scope"> {{scope.row.auxiliaryRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="directorRatio" label="主管比例" width="200">
                        <template slot-scope="scope"> {{scope.row.directorRatio}}%</template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="200"></el-table-column>
                    <el-table-column prop="createBy" label="创建人" width="200"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="update(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination
                    small
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10,20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <!--  -->

        <el-drawer
            :title="title"
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose"
            size="90%">
            <PercentageUpdate :key="timer" :percentageProp="percentageProp"></PercentageUpdate>
        </el-drawer> 
        
    </div>
    
</template>

<script>
    import PercentageUpdate from './PercentageUpdate.vue';

    export default {
        name:'Percentage',
        components: {
            PercentageUpdate
        },
        data() {
            return {
                percentage:{
                    condition:{},
                    pageNum: 1,
                    pageSize:10
                },
                drawer: false,
                direction: 'rtl',
                percentages: [],
                currentPage: 1,
                pageSize:10,
                total:10,
                timer:'',
                percentageProp:{},
                title:"新增提成比例",
                dataStatuses:[],
                dialogFormVisible: false,
                formLabelWidth:"100px",
                loading: true,
            }
        },
        methods: {
            update(row) {
                this.title = "修改提成比例";
                this.drawer = true;
                this.percentageProp = row;
                this.timer = new Date().getTime();
            },
            handleDelete(row) {
                this.$confirm('确认删除？')
                .then(()=> {
                    this.doDelete(row);
                })
                .catch(() => {});
            },
            doDelete(row) {
                this.$axios.post("/percentage/delete",row).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.$message.error("删除成功！");
                            this.queryPercentage();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
            },
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pageSize = val;
                this.queryPercentage();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryPercentage();
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                .then(()=> {
                    done();
                    this.queryPercentage();
                })
                .catch(() => {});
            },
            queryPercentage() {
                this.loading = true;
                this.percentage.pageNum = this.currentPage;
                this.percentage.pageSize = this.pageSize;
                this.$axios.post("/percentage/find",this.percentage).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.percentages = res.data.result.list;
                            this.total = res.data.result.total;
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.loading = false;
                    }, error => {
                        this.$message.error(error.message);
                    });
            },
            createPercentage() {
                this.title = "新增提成比例";
                this.drawer = true;
                this.timer = new Date().getTime();
                this.percentageProp = {};
            },
            queryStatus() {
                let condition = {value:"DATA_STATUS"};
                this.$axios.post("/dictionary/findByDictType",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.dataStatuses = res.data.result;
                        } else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            },
            formatStatus(row) {
                return row.percentageStatus == "NORMAL" ? "正常": row.percentageStatus == "FROZEN" ? "冻结" : "已删除";
            },
            handleCloseDrawer() {
                this.drawer = false;
                this.queryPercentage();
            }
        },
        mounted() {
            this.$bus.$on(this.GlobeConstant.percentageupdate_to_percentage_close, this.handleCloseDrawer);
            this.queryPercentage();
            this.queryStatus();
        },
        beforeDestroy() {
            this.$bus.$off(this.GlobeConstant.percentageupdate_to_percentage_close)
        }
        
    }


</script>

<style scoped>

   .el-form {
       margin-top: 30px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .line {
        text-align: center;
   }
   .el-select {
        width: 220px;
    }

    .el-input {
        width: 220px;
    }
    
</style>
